import {
  getRequestV2,
  postRequestV2,
  patchRequestV2,
  patchRequest,
  deleteRequestV2,
} from 'utils/api/methods';

const getWorkspaces = () => getRequestV2('power_bi/workspaces');

const getReports = (workspaceId: string) =>
  getRequestV2(`power_bi/workspaces/${workspaceId}/reports`);

const reportEmbedToken = (workspaceId: string, reportId: string) =>
  postRequestV2(
    `power_bi/workspaces/${workspaceId}/reports/${reportId}/embed_tokens`,
    {}
  );

const executeQuery = (payload: { datasetId: string; daxExpression: string }) =>
  postRequestV2(`power_bi/queries/preview`, payload);

const saveQuery = (payload: {
  datasetId: string;
  daxExpression: string;
  workspaceId: string;
  workspaceName: string;
  reportId: string;
  reportName: string;
  targetId: number;
  targetType: 'KeyResult' | 'KPI';
}) => postRequestV2(`power_bi/queries`, payload);

const updateQuery = (
  queryId: number,
  payload: {
    datasetId: string;
    daxExpression: string;
    workspaceId: string;
    workspaceName: string;
    reportId: string;
    reportName: string;
  }
) => patchRequestV2(`power_bi/queries/${queryId}`, payload);

const removeQuery = (queryId: number) =>
  deleteRequestV2(`power_bi/queries/${queryId}`);

const updatePowerBiSetting = (payload: { enabled: boolean }) =>
  patchRequest('settings/integrations/power_bi', payload);

const powerBi = {
  getWorkspaces,
  getReports,
  reportEmbedToken,
  executeQuery,
  saveQuery,
  updateQuery,
  removeQuery,
  updatePowerBiSetting,
};

export default powerBi;
